<template>
  <b-overlay :show="showLoading" rounded="lg">
    <!-- Stats Cards Row -->
    <b-row>
      <b-col cols="12" sm="6" lg="2" class="mb-4">
        <b-card class="stat-card h-100">
          <div class="stat-icon float-left">
            <i class="fas fa-files text-primary"></i>
          </div>
          <div class="stat-label">تعداد کل فایل‌ها</div>
          <div class="stat-value">{{ totalFiles }}</div>
        </b-card>
      </b-col>
      <b-col v-if="myUsage" cols="12" sm="6" lg="2" class="mb-4">
        <b-card class="stat-card h-100">
          <div class="stat-icon float-left">
            <i class="fas fa-database text-success"></i>
          </div>
          <div class="stat-label">حجم کل</div>
          <div class="stat-value">{{ formatSize(myUsage.maxQuota) }}</div>
        </b-card>
      </b-col>
      <b-col cols="12" sm="6" lg="2" class="mb-4">
        <b-card class="stat-card h-100">
          <div class="stat-icon float-left">
            <i class="fas fa-database text-success"></i>
          </div>
          <div class="stat-label">حجم  مصرفی</div>
          <div class="stat-value">{{ formatSize(totalSize) }}</div>
        </b-card>
      </b-col>
      <b-col v-if="myUsage" cols="12" sm="6" lg="2" class="mb-4">
        <b-card class="stat-card h-100">
          <div class="stat-icon float-left">
            <i class="fas fa-database text-success"></i>
          </div>
          <div class="stat-label">حجم باقی‌مانده</div>
          <div class="stat-value">{{ formatSize(myUsage.remaining) }}</div>
        </b-card>
      </b-col>


      <b-col cols="12" sm="6" lg="4" class="mb-4">
        <b-card class="stat-card h-100">
          <div class="stat-icon float-left">
            <i class="fas fa-percent text-warning"></i>
          </div>
          <div class="stat-label">درصد مصرف فضا</div>
          <div class="stat-value">{{ usagePercent }}%</div>
          <b-progress
              :value="usagePercent"
              :max="100"
              class="mt-2"
              height="8px"
              variant="primary"
              :class="{'bg-danger': usagePercent > 80, 'bg-warning': usagePercent > 60 && usagePercent <= 80}"
          />
        </b-card>
      </b-col>

<!--      <b-col cols="12" sm="6" lg="3" class="mb-4">-->
<!--        <b-card class="stat-card h-100">-->
<!--          <div class="stat-icon float-left">-->
<!--            <i class="fas fa-clock text-info"></i>-->
<!--          </div>-->
<!--          <div class="stat-label">آخرین بروزرسانی</div>-->
<!--          <div class="stat-value" style="font-size: 1.2rem;">-->
<!--            {{ formatDate(lastUpdate) }}-->
<!--          </div>-->
<!--        </b-card>-->
<!--      </b-col>-->
    </b-row>

    <!-- Breakdown Row: Media Type + Status + Variant Breakdown -->
    <b-row>
      <b-col cols="12" md="6" lg="4" class="mb-4">
        <b-card class="h-100">
          <template #header>
            <h5 class="mb-0">
              <i class="fas fa-chart-pie text-primary mr-2"></i>
              تفکیک بر اساس نوع رسانه
            </h5>
          </template>
          <b-list-group flush>
            <b-list-group-item
                v-for="(item,idx) in typeStats"
                :key="idx"
                class="d-flex justify-content-between align-items-center px-0"
            >
              <span>
                <i :class="['fas', item.icon, 'text-primary mr-2']"></i>
                {{ item.label }}
              </span>
              <span class="font-weight-bold">
                {{ item.count }} فایل ({{ formatSize(item.size) }})
              </span>
            </b-list-group-item>
          </b-list-group>
        </b-card>
      </b-col>

      <b-col cols="12" md="6" lg="4" class="mb-4">
        <b-card class="h-100">
          <template #header>
            <h5 class="mb-0">
              <i class="fas fa-chart-simple text-primary mr-2"></i>
              وضعیت فایل‌ها
            </h5>
          </template>
          <b-list-group flush>
            <b-list-group-item
                v-for="(item,idx) in statusStats"
                :key="idx"
                class="d-flex justify-content-between align-items-center px-0"
            >
              <span>
                <span class="status-dot" :style="{ backgroundColor: item.color }"></span>
                {{ item.label }}
              </span>
              <span class="font-weight-bold">{{ item.count }}</span>
            </b-list-group-item>
          </b-list-group>
        </b-card>
      </b-col>

      <b-col cols="12" md="6" lg="4" class="mb-4">
        <b-card class="h-100">
          <template #header>
            <h5 class="mb-0">
              <i class="fas fa-layer-group text-primary mr-2"></i>
              تفکیک مصرف بر اساس نوع نسخه
            </h5>
          </template>
          <b-list-group flush>
            <b-list-group-item
                v-for="(item,idx) in variantStats"
                :key="idx"
                class="d-flex justify-content-between align-items-center px-0"
            >
              <span>
                <i :class="['fas', item.icon, 'text-primary mr-2']"></i>
                {{ item.label }}
              </span>
              <span class="font-weight-bold">
                {{ item.count }} فایل ({{ formatSize(item.size) }})
              </span>
            </b-list-group-item>
          </b-list-group>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
import {BCard, BCol, BListGroup, BListGroupItem, BOverlay, BProgress, BRow} from 'bootstrap-vue'
import {
  MediaLibraryAdminReportRequest,
  MediaLibraryGetMyUsageRequest,
  MediaLibraryGetUsageDetailsRequest
} from '@/libs/Api/MediaLibrary'
import ToastificationContent from '@core/components/toastification/ToastificationContent'

export default {
  name: 'DashboardPage',
  components: {
    BCard,
    BRow,
    BCol,
    BOverlay,
    BProgress,
    BListGroup,
    BListGroupItem
  },
  data() {
    return {
      showLoading: false,
      adminReport: null,
      myUsage: null,
      usageDetails: null // new
    }
  },
  computed: {
    totalFiles() {
      return this.adminReport?.totalFiles || 0
    },
    totalSize() {
      return this.adminReport?.totalSize || 0
    },
    maxLimit() {
      return this.myUsage?.maxLimit || 500_000_000
    },
    usagePercent() {
      return this.myUsage?.usagePercent
    },
    lastUpdate() {
      // Use report generation date if available, else now
      if (this.adminReport?.reportGeneratedAt) {
        return this.adminReport.reportGeneratedAt
      }
      return new Date()
    },
    // Media type breakdown (from admin report)
    typeStats() {
      const stats = this.adminReport?.statsByType || {}
      const map = {
        Image: { label: 'تصویر', icon: 'fa-image' },
        Video: { label: 'ویدیو', icon: 'fa-video' },
        Audio: { label: 'صوتی', icon: 'fa-music' },
        Document: { label: 'سند', icon: 'fa-file-alt' }
      }
      return Object.entries(stats).map(([type, data]) => ({
        type: parseInt(type),
        label: map[type]?.label || 'ناشناخته',
        icon: map[type]?.icon || 'fa-file',
        count: data.count || 0,
        size: data.totalSize || 0
      }))
    },
    // Status breakdown (from admin report)
    statusStats() {
      const stats = this.adminReport?.statsByStatus || {}
      const map = {
        Pending: { label: 'در انتظار', color: '#f59e0b' },
        Processing: { label: 'در حال پردازش', color: '#3b82f6' },
        Processed: { label: 'پردازش شده', color: '#22c55e' },
        Failed: { label: 'ناموفق', color: '#ef4444' }
      }
      return Object.entries(stats).map(([status, count]) => ({
        status: parseInt(status),
        label: map[status]?.label || 'ناشناخته',
        color: map[status]?.color || '#94a3b8',
        count: count || 0
      }))
    },
    // Variant breakdown (from usage-details)
    variantStats() {
      const breakdown = this.usageDetails?.breakdownByType || {}
      const map = {
        'ORIGINAL': { label: '📁 فایل اصلی', icon: 'fa-file' },
        'THUMBNAIL': { label: '🖼️ تامب‌نیل', icon: 'fa-image' },
        'WEBP': { label: '🌐 WebP', icon: 'fa-image' },
        'WATERMARKED': { label: '🔰 واترمارک', icon: 'fa-watermark' }, // fallback icon
        'HLS_MASTER': { label: '📋 پلی‌لیست اصلی', icon: 'fa-list' },
        'PREVIEW': { label: '🎬 پیش‌نمایش', icon: 'fa-play' }
      }
      // Handle dynamic HLS qualities and Preview_* keys
      const sortedKeys = Object.keys(breakdown).sort((a, b) => {
        const order = ['ORIGINAL', 'THUMBNAIL', 'WEBP', 'WATERMARKED', 'HLS_MASTER'];
        const aIdx = order.indexOf(a);
        const bIdx = order.indexOf(b);
        if (aIdx !== -1 && bIdx !== -1) return aIdx - bIdx;
        if (aIdx !== -1) return -1;
        if (bIdx !== -1) return 1;
        return a.localeCompare(b);
      });

      return sortedKeys.map(type => {
        const info = breakdown[type]
        let label, icon
        if (type.startsWith('HLS_')) {
          const quality = type.replace('HLS_', '')
          label = `📺 HLS (${quality})`
          icon = 'fa-film'
        } else if (type.startsWith('Preview_')) {
          label = `🎬 پیش‌نمایش (${type.replace('Preview_', '')})`
          icon = 'fa-play'
        } else {
          const mapped = map[type]
          label = mapped?.label || type
          icon = mapped?.icon || 'fa-file'
        }
        return {
          type,
          label,
          icon,
          count: info.count || 0,
          size: info.totalSize || 0
        }
      })
    }
  },
  async created() {
    await this.fetchData()
  },
  methods: {
    formatDate(iso) {
      if (!iso) return '—'
      const d = new Date(iso)
      return d.toLocaleDateString('fa-IR') + ' ' + d.toLocaleTimeString('fa-IR', { hour: '2-digit', minute: '2-digit' })
    },
    formatSize(bytes) {
      if (bytes === 0) return '0 B'
      const k = 1024
      const sizes = ['B', 'KB', 'MB', 'GB', 'TB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
    },
    async fetchData() {
      this.showLoading = true
      try {
        await Promise.all([
          this.fetchAdminReport(),
          this.fetchMyUsage(),
          this.fetchUsageDetails() // new
        ])
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: 'خطا در بارگذاری',
            icon: 'XIcon',
            variant: 'danger',
            text: error.message || 'مشکل در دریافت اطلاعات'
          }
        })
      } finally {
        this.showLoading = false
      }
    },
    fetchAdminReport() {
      return new Promise((resolve, reject) => {
        const request = new MediaLibraryAdminReportRequest(this)
        request.fetch(
            (content) => {
              this.adminReport = content
              resolve(content)
            },
            (error) => {
              console.error('Admin report error:', error)
              reject(error)
            }
        )
      })
    },
    fetchMyUsage() {
      return new Promise((resolve, reject) => {
        const request = new MediaLibraryGetMyUsageRequest(this)
        request.fetch(
            (content) => {
              this.myUsage = content
              resolve(content)
            },
            (error) => {
              console.error('My usage error:', error)
              reject(error)
            }
        )
      })
    },
    fetchUsageDetails() {
      return new Promise((resolve, reject) => {
        const request = new MediaLibraryGetUsageDetailsRequest(this)
        request.fetch(
            (content) => {
              this.usageDetails = content
              resolve(content)
            },
            (error) => {
              console.error('Usage details error:', error)
              reject(error)
            }
        )
      })
    }
  }
}
</script>

<style scoped>
.stat-card {
  border: none;
  border-radius: 18px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  transition: all 0.25s ease;
}
.stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.06);
}
.stat-icon {
  font-size: 30px;
  opacity: 0.5;
}
.stat-label {
  font-size: 14px;
  color: #64748b;
  font-weight: 500;
}
.stat-value {
  font-size: 30px;
  font-weight: 700;
  color: #0f172a;
  margin-top: 4px;
}
.status-dot {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-left: 8px;
}
</style>
